import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import logo from "../../assets/images/logo.svg";
import { logout } from "../../actions/auth";
import { hardLogoutOrenda } from "./orendaUserManager";
import { clearOrendaAuth } from "./orendaAuthStorage";

// Left navigation rail for Orenda cardholders — mirrors the classic Navigation
// visual language (sidebar with logo, nav items, logout footer) but with its
// own component so we can grow it independently without touching the old nav.
//
// MVP has a single "Dashboard" entry. Future entries (My Cards, Transactions,
// Settings, Help) are added here as we build those screens.

const OrendaNav = ({ activePath = "dashboard" }) => {
  const { user: currentUser } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  const signOutEverything = () => {
    try { clearOrendaAuth(); } catch { /* ignore */ }
    dispatch(logout());
    hardLogoutOrenda();
  };

  const name = currentUser?.user?.Name || "";
  const clientLogo = currentUser?.user?.ClientLogoUrl;

  return (
    <div className="col-lg-3 col-md-0 bo-sidebar-col orenda-nav" id="leftNav">
      <div className="bo-sidebar-outer">
        <Link to="/orenda-landing" className="orenda-nav-logo">
          <div className="orenda-nav-wordmark">
            <span className="orenda-nav-wordmark-bo">bo</span>
            <span className="orenda-nav-wordmark-payments">payments</span>
          </div>
        </Link>

        <nav className="orenda-nav-items">
          <Link
            to="/orenda-landing"
            className={`orenda-nav-item ${activePath === "dashboard" ? "orenda-nav-item--active" : ""}`}
          >
            <NavIcon kind="dashboard" />
            <span>Dashboard</span>
          </Link>
          {/* Future: My Cards / Transactions / Settings / Help — add here. */}
        </nav>

        <div className="orenda-nav-footer">
          <button
            type="button"
            className="orenda-nav-logout"
            onClick={signOutEverything}
          >
            <NavIcon kind="logout" />
            <div>
              <div className="orenda-nav-logout-label">Logout</div>
              {name && <div className="orenda-nav-logout-name">{name}</div>}
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

const NavIcon = ({ kind }) => {
  const common = {
    width: 20,
    height: 20,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    "aria-hidden": true,
  };
  if (kind === "dashboard") {
    return (
      <svg viewBox="0 0 24 24" {...common}>
        <rect x="3" y="3" width="7" height="9" rx="1" />
        <rect x="14" y="3" width="7" height="5" rx="1" />
        <rect x="14" y="12" width="7" height="9" rx="1" />
        <rect x="3" y="16" width="7" height="5" rx="1" />
      </svg>
    );
  }
  if (kind === "logout") {
    return (
      <svg viewBox="0 0 24 24" {...common}>
        <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
        <polyline points="16 17 21 12 16 7" />
        <line x1="21" y1="12" x2="9" y2="12" />
      </svg>
    );
  }
  return null;
};

export default OrendaNav;
